//TODO: Este documento se crea para las apis que se ocuapn de paquetes V2 del mayorista

import axios from "axios"
import { APIURL } from "./../Constantes"
import { getCabecera } from "../utils/getCabecera"
import { getError } from "../utils/errors"
const urlFligth = "Fligth"

//* Metodo para traer todos los vuleos paginado
//* GET /api/Fligth/V2/Supplier/{IdProveedor}/{Pagina}/{Registros}
export const getVuelosProveedorAll = async ({ IdProveedor, Pagina, Registros}) => {
    return await axios.get(`${APIURL}/${urlFligth}/V2/Supplier/${IdProveedor}/${Pagina}/${Registros}`, {
        headers: getCabecera()
    }).then((Response) => {
        return Response.data
    }).catch((Error) => {
        return {}
        // return getError(Error);
    })
}

//* Metodo para buscar vuelos por id proveedor
//* GET /api/Fligth/V2/Supplier/{IdProveedor}
export const getVuelosProveedorID = async ({ IdProveedor }) => {
    return await axios.get(`${APIURL}/${urlFligth}/V2/Supplier/${IdProveedor}`, {
        headers: getCabecera()
    }).then((Response) => {
        return Response.data
    }).catch((Error) => {
        return []
        // return getError(Error);
    })
}
//* Metodo para agregar vuelo proveedor
//* POST /api/Fligth/V2/Supplier 
export const newVueloProveedor = async ({
    IdProveedor,
    IdCatVueloClase,
    IdCatRegion,
    IdMoneda,
    ClaveVuelo,
    PrecioNeto,
    Disponibilidad,
    FechaSalida,
    FechaLlegada,
    IdOrigen,
    IdDestino,
    Itinerario,
    Incluye,
    NoIncluye,
    EsRedondo,
    VueloRedondo,
    lCatIncluye
}) => {
    return await axios.post(`${APIURL}/${urlFligth}/V2/Supplier`, {
        IdProveedor,
        IdCatVueloClase,
        IdCatRegion,
        IdMoneda,
        ClaveVuelo,
        PrecioNeto,
        Disponibilidad,
        FechaSalida,
        FechaLlegada,
        IdOrigen,
        IdDestino,
        Itinerario,
        Incluye,
        NoIncluye,
        EsRedondo,
        VueloRedondo,
        lCatIncluye
    }, {
        headers: getCabecera()
    }).then((Response) => {
        return Response.data
    }).catch((Error) => {
        return getError(Error);
    })
}
//* Metodo para actulizar vuelos proveedor
//* PUT /api/Fligth/V2/Supplier/{IdVueloProveedor}
export const putVueloProveedor = async ({ 
    IdVueloProveedor,
    IdCatVueloClase,
    IdCatRegion,
    IdProveedor,
    IdMoneda,
    ClaveVuelo,
    PrecioNeto,
    Disponibilidad,
    FechaSalida,
    FechaLlegada,
    IdOrigen,
    IdDestino,
    Itinerario,
    Incluye,
    NoIncluye,
    EsRedondo,
    Estatus,
    VueloRedondo,
    lCatIncluye
 }) => {
    return await axios.put(`${APIURL}/${urlFligth}/V2/Supplier/${IdVueloProveedor}`, {
        IdProveedor,
        IdCatVueloClase,
        IdCatRegion,
        IdMoneda,
        ClaveVuelo,
        PrecioNeto,
        Disponibilidad,
        FechaSalida,
        FechaLlegada,
        IdOrigen,
        IdDestino,
        Itinerario,
        Incluye,
        NoIncluye,
        EsRedondo,
        Estatus,
        VueloRedondo,
        lCatIncluye
    },{
        headers: getCabecera()
    }).then((Response) => {
        return Response.data
    }).catch((Error) => {
        return getError(Error);
    })
}
//* Metodo para obtener lista de vuelos 
//* GET /api/Fligth/V2/Supplier/List
export const getVuelosProveedoLista = async () => {
    return await axios.get(`${APIURL}/${urlFligth}/V2/Supplier/List`,{
        headers: getCabecera()
    }).then(Response => {
        return Response.data
    }).catch(Error => {
        return []
    })
}

//* Metodo para obtener los extras de un vuelo
//* GET /api/Fligth/V2/Supplier/{IdVueloProveedor}
export const getExtrasVuelo = async ({ IdVuelo }) => {
    return await axios.get(`${APIURL}/${urlFligth}/V2/Supplier/Extra/${IdVuelo}`, {
        headers: getCabecera()
    }).then(Response => {
        return Response.data
    }).catch(Error => {
        return []
    })
}

//* Metodo para obtener los extras de un vuelo de regreso
//* GET /api/Flight/V2/Supplier/Round/{IdVueloProveedor}
export const getExtrasVueloRegreso = async ({ IdVuelo }) => {
    return await axios.get(`${APIURL}/${urlFligth}/V2/Supplier/Round/Extra/${IdVuelo}`, {
        headers: getCabecera()
    }).then(Response => {
        return Response.data
    }).catch(Error => {
        return []
    })
}

//* Metodo para crear nuevo extra de vuelo
//* POST /api/Flight/V2/Supplier/Extra
export const newExtraVuelo = async ({ IdVueloProveedor, IdExtra, Descripcion, Suplemento }) => {
    return await axios.post(`${APIURL}/${urlFligth}/V2/Supplier/Extra`, {
        IdVueloProveedor,
        IdExtra,
        Suplemento,
        Descripcion,
    }, {
        headers: getCabecera()
    }).then((Response) => {
        return Response.data
    }).catch((Error) => {
        return getError(Error);
    })
}

//* Metodo para crear nuevo extra de vuelo regreso
//* POST /api/Flight/V2/Supplier/Round/Extra
export const newExtraVueloRegreso = async ({ IdVueloRedondo, IdExtra, Descripcion, Suplemento }) => {
    return await axios.post(`${APIURL}/${urlFligth}/V2/Supplier/Round/Extra`, {
        IdVueloRedondo,
        IdExtra,
        Suplemento,
        Descripcion,
    }, {
        headers: getCabecera()
    }).then((Response) => {
        return Response.data
    }).catch((Error) => {
        return getError(Error);
    })
}

//* Metodo para actualizar extra de vuelo
//* PUT /api/Flight/V2/Supplier/Round/{IdExtra}
export const updateExtraVuelo = async ({ IdVueloProveedorExtra, IdExtra, IdVueloProveedor, Descripcion, Suplemento, Estatus }) => {
    return await axios.put(`${APIURL}/${urlFligth}/V2/Supplier/Extra/${IdVueloProveedorExtra}`, {
        IdVueloProveedor,
        IdExtra,
        Descripcion,
        Suplemento,
        Estatus
    }, {
        headers: getCabecera()
    }).then((Response) => {
        return Response.data
    }).catch((Error) => {
        return getError(Error);
    })
}

export const updateExtraVueloRegreso = async ({ IdVueloRedondoExtra, IdVueloRedondo, IdExtra, Descripcion, Suplemento, Estatus }) => {
    return await axios.put(`${APIURL}/${urlFligth}/V2/Supplier/Round/Extra/${IdVueloRedondoExtra}`, {
        IdVueloRedondo,
        IdExtra,
        Descripcion,
        Suplemento,
        Estatus
    }, {
        headers: getCabecera()
    }).then((Response) => {
        return Response.data
    }).catch((Error) => {
        return getError(Error);
    })
}

//* Metodo para eliminar extra de vuelo
//* DELETE /api/Flight/V2/Supplier/Extra/{IdVueloProveedorExtra}
export const deleteExtraVuelo = async ({ IdVueloProveedorExtra }) => {
    return await axios.delete(`${APIURL}/${urlFligth}/V2/Supplier/Extra/${IdVueloProveedorExtra}`, {
        headers: getCabecera()
    }).then((Response) => {
        return Response.data
    }).catch((Error) => {
        return getError(Error);
    })
}

//*Metodo para eliminar extra de vuelo regreso
//* DELETE /api/Flight/V2/Supplier/Round/Extra/{IdVueloRedondoExtra}
export const deleteExtraVueloRegreso = async ({ IdVueloRedondoExtra }) => {
    return await axios.delete(`${APIURL}/${urlFligth}/V2/Supplier/Round/Extra/${IdVueloRedondoExtra}`, {
        headers: getCabecera()
    }).then((Response) => {
        return Response.data
    }).catch((Error) => {
        return getError(Error);
    })
}

//*Metodo para cambiar el tipo de extra de vuelo
//* PUT /api/Flight/V2/Supplier/Extra/Historic
export const actualizaTipoExtraVuelo = async ({ idExtra, idCatExtra, imagen, extencion }) => {
    return await axios.put(`${APIURL}/${urlFligth}/V2/Supplier/Extra/Historic`, {
        idCatExtra,
        idExtra,
        imagen,
        extencion,
    }, {
        headers: getCabecera()
    }).then((Response) => {
        return Response.data
    }).catch((Error) => {
        return getError(Error);
    })
}

//*Metodo para cambiar el tipo de extra de vuelo regreso
//* PUT /api/Flight/V2/Supplier/Round/Extra/Historic
export const actualizaTipoExtraVueloRegreso = async ({ idExtra, idCatExtra, imagen, extencion }) => {
    return await axios.put(`${APIURL}/${urlFligth}/V2/Supplier/Round/Extra/Historic`, {
        idCatExtra,
        idExtra,
        imagen,
        extencion,
    }, {
        headers: getCabecera()
    }).then((Response) => {
        return Response.data
    }).catch((Error) => {
        return getError(Error);
    })
}

//* Metodo para obtener los vuelos por circuito proveedor
// * GET /api/Flight/V2/Supplier/Circuit/{IdPaqueteCircuito}/{Pagina}/{Registros}
export const getVuelosPorCircuito = async ({ IdPaqueteCircuito, Pagina, Registros }) => {
    return await axios.get(`${APIURL}/${urlFligth}/V2/Supplier/Circuit/${IdPaqueteCircuito}/${Pagina}/${Registros}`, {
        headers: getCabecera()
    }).then(Response => {
        return Response.data
    }).catch(Error => {
        return []
    })
}

// * Metodo para obtener las escalas de vuelos
// * GET /api/Fligth/V2/Supplier/Connecting/{IdVueloProveedor}
export const getEscalasVuelo = async ({ IdVueloProveedor }) => {
    return await axios.get(`${APIURL}/${urlFligth}/V2/Supplier/Connecting/${IdVueloProveedor}`, {
        headers: getCabecera()
    }).then(Response => {
        return Response.data
    }).catch(Error => {
        return []
    })
}

// * Metodo para crear escalas de vuelos
// * POST /api/Fligth/V2/Supplier/Connecting
export const newEscalaVuelo = async ({ IdVueloProveedor, IdCodigo }) => {
    return await axios.post(`${APIURL}/${urlFligth}/V2/Supplier/Connecting`, {
        IdVueloProveedor,
        IdCodigo,
    }, {
        headers: getCabecera()
    }).then(Response => {
        return Response.data
    }).catch(Error => {
        return []
    })
}

//  * Metodo para actualizar escalas de vuelos
//  * PUT /api/Fligth/V2/Supplier/Connecting/Order/{IdVueloProveedorEscala}
export const updateEscalaVuelo = async ({ IdVueloProveedorEscala, Orden }) => {
    return await axios.put(`${APIURL}/${urlFligth}/V2/Supplier/Connecting/Order/${IdVueloProveedorEscala}`, {
        Orden
    }, {
        headers: getCabecera()
    }).then(Response => {
        return Response.data
    }).catch(Error => {
        return []
    })
}

// * Metodo para eliminar la escala de vuelo
// * DELETE /api/Fligth/V2/Supplier/Connecting/{IdVueloProveedorEscala}
export const eliminarEscalaVuelo = async ({ IdVueloProveedorEscala }) => {
    return await axios.delete(`${APIURL}/${urlFligth}/V2/Supplier/Connecting/${IdVueloProveedorEscala}`, {
        headers: getCabecera()
    }).then(Response => {
        return Response.data
    }).catch(Error => {
        return []
    })
}

// * Metodo para obtener escalas de vuelos regreso
// * GET /api/Flight/V2/Supplier/Round/Connecting/{IdVueloRedondo}
export const getEscalasVueloRegreso = async ({ IdVueloRedondo }) => {
    return await axios.get(`${APIURL}/${urlFligth}/V2/Supplier/Round/Connecting/${IdVueloRedondo}`, {
        headers: getCabecera()
    }).then(Response => {
        return Response.data
    }).catch(Error => {
        return []
    })
}

// * Metodo para crear escalas de vuelos regreso
// * POST /api/Flight/V2/Supplier/Round/Connecting
export const newEscalaVueloRegreso = async ({ IdVueloRedondo, IdCodigo }) => {
    return await axios.post(`${APIURL}/${urlFligth}/V2/Supplier/Round/Connecting`, {
        IdVueloRedondo,
        IdCodigo,
    }, {
        headers: getCabecera()
    }).then(Response => {
        return Response.data
    }).catch(Error => {
        return []
    })
}

//  * Metodo para actualizar escalas de vuelos regreso
//  * PUT /api/Fligth/V2/Supplier/Round/Connecting/Order/{IdVueloRedondoEscala}
export const updateEscalaVueloRegreso = async ({ IdVueloRedondoEscala, Orden }) => {
    return await axios.put(`${APIURL}/${urlFligth}/V2/Supplier/Round/Connecting/Order/${IdVueloRedondoEscala}`, {
        Orden
    }, {
        headers: getCabecera()
    }).then(Response => {
        return Response.data
    }).catch(Error => {
        return []
    })
}

// * Metodo para eliminar la escala de vuelo
// * DELETE /api/Fligth/V2/Supplier/Round/Connecting/{IdVueloRedondoEscala}
export const eliminarEscalaVueloRegreso = async ({ IdVueloRedondoEscala }) => {
    return await axios.delete(`${APIURL}/${urlFligth}/V2/Supplier/Round/Connecting/${IdVueloRedondoEscala}`, {
        headers: getCabecera()
    }).then(Response => {
        return Response.data
    }).catch(Error => {
        return []
    })
}